import React, { lazy } from 'react';
import { Route, IndexRoute } from 'react-router';

const WizardRedirector = lazy(
  () => import('./components/wizardRedirect/WizardRedirector'),
);
const ExamDecisionModal = lazy(
  () => import('./components/examDecision/ExamDecisionModal'),
);
const VideoPage = lazy(() => import('./components/video/VideoPage'));
const VideoQuestionsComponent = lazy(
  () => import('./components/video/VideoQuestionsComponent'),
);
const GraphqlProvider = lazy(() => import('./utils/GraphqlProvider'));

export const wizardPageRoutes = (
  <Route path="/wizards" component={GraphqlProvider}>
    <IndexRoute component={WizardRedirector} />
    <Route path="video" component={VideoPage} />
    <Route path="questions/:fromTodo" component={VideoQuestionsComponent} />
  </Route>
);
export const wizardModalRoutes = (
  <Route path="/wizards" component={GraphqlProvider}>
    <Route path="decision/:fromTodo" component={ExamDecisionModal} />
  </Route>
);

export default {
  wizardPageRoutes,
  wizardModalRoutes,
};
